import { render, staticRenderFns } from "./help-info.vue?vue&type=template&id=1227b8c3&scoped=true"
import script from "./help-info.vue?vue&type=script&lang=js"
export * from "./help-info.vue?vue&type=script&lang=js"
import style0 from "./help-info.vue?vue&type=style&index=0&id=1227b8c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1227b8c3",
  null
  
)

export default component.exports